import { binaryRepoImagesApi } from '~/lib/api/client';

/**
 * Attribute / attribute-value image upload.
 *
 * Server contract (Core/server/API/Controllers/System/BinaryRepoImagesController.cs
 * `UploadAttribute` / `UploadAttributeValue` + IBinImageProcessor.ProcessUploadedImage), mirroring
 * the product two-phase flow (lib/api/product-image-upload.ts):
 *   - The image SUBKEY is the slot number as a string — "1" / "2" for attributes, "1" for values.
 *   - Against an EXISTING id (id > 0) the upload commits the BinaryRepoImage row IMMEDIATELY, so the
 *     orchestrator inserts/updates the entity FIRST, then uploads against the real id.
 *   - Image DELETION is NOT driven by the token's img{n} fields — only the imgdel{n}/DeleteImage_{n}
 *     flags on the update token delete an image (handled in the Attributes/AttributeValues controllers).
 *   - The generated upload methods drop the multipart body, so we attach the File via `options.data`
 *     as multipart/form-data. The server reads `Request.Form.Files.FirstOrDefault()`, so the form
 *     field name is irrelevant.
 */
function toFormData(file: File): FormData {
	const fd = new FormData();
	fd.append('file', file);
	return fd;
}

export async function uploadAttributeImage(id: number, key: '1' | '2', file: File): Promise<void> {
	await binaryRepoImagesApi.uploadAttribute(id, key, { data: toFormData(file) });
}

export async function uploadAttributeValueImage(id: number, key: '1', file: File): Promise<void> {
	await binaryRepoImagesApi.uploadAttributeValue(id, key, { data: toFormData(file) });
}
